export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecionar loja"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sem título"])}
}